<template>
    <div class="action-group">
        <el-button @click="$refs.list.open()" type="primary" size="mini">{{ $t('lang.食材单位管理') }}</el-button>
        <unit-list ref="list"></unit-list>
    </div>
</template>

<script>
    import UnitList from "../food-unit/UnitList";
    export default {
        name: "ActionGroup",
        components: {UnitList}
    }
</script>

<style scoped>
.action-group{
    margin-bottom: 12px;
}
</style>
